import { Breadcrumb, Upload, Modal, Row, Col, Button, DatePicker, Radio, Card, Input, Popconfirm, Checkbox, Empty, Alert } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ExclamationCircleFilled, PlusOutlined, SettingFilled } from '@ant-design/icons';
import AdminModal from "./AdminModal";
const { TextArea } = Input;
const FeedbackModal = (props) => {
    useEffect(() => {
        // console.log(props.editcard)
    }, [props.editcard])
    return (
        <>
            <AdminModal
                crm={true}
                {...props}
                title={(<>
                    <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 55, left: 30 }} >{props.title}</Col>
                </>)}
                uploads
            >
                <Row gutter={[10, 10]} >
                    <Col span={24}>
                        <Row gutter={[8, 8]} align={'middle'} hidden>
                            <Col span={6}>需求修改項目</Col>
                            <Col span={18}>
                                <TextArea rows={4} placeholder="請輸入需求修改項目" value={props.editcard['item']}
                                    onChange={e => props.setEditCard(prev => {
                                        return (
                                            {
                                                ...prev,
                                                item: e.target.value,
                                            }
                                        )
                                    })} />
                            </Col>
                        </Row>
                        <Row gutter={[8, 8]} align={'middle'}>
                            <Col span={6}>修改原因</Col>
                            <Col span={18}>
                                <TextArea rows={4} placeholder="請詳細說明，需修改原因" value={props.editcard['reason']}
                                    onChange={e => props.setEditCard(prev => {
                                        return (
                                            {
                                                ...prev,
                                                reason: e.target.value,
                                            }
                                        )
                                    })}
                                />
                            </Col>
                        </Row>
                        <Row gutter={[8, 8]} align={'middle'} hidden>
                            <Col span={6}>驗收測試範例</Col>
                            <Col span={18}>
                                <TextArea rows={4} placeholder="請輸入驗收測試範例" value={props.editcard['accepting_test']}
                                    onChange={e => props.setEditCard(prev => {
                                        return (
                                            {
                                                ...prev,
                                                accepting_test: e.target.value,
                                            }
                                        )
                                    })} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </AdminModal>
            {false && <Modal hidden
                // width={'auto'}
                style={{ pointerEvents: 'auto' }}
                open={props.open}
                bodyStyle={{ backgroundColor: props.edit ? '#faf6f5' : '##FCF5F6' }}
                width={450}
                footer={false}
                data={props.data}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: props.edit ? '#faf6f5' : '#FCF5F6', padding: '20px', borderTop: `solid #${props.color} 5px ` }}>
                        <Row gutter={[10, 10]} >
                            <Col span={24}>
                                <Row justify="space-between" align={'bottom'}>
                                    {props.edit ?
                                        <>
                                            <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/edit.png'></img>
                                        </> :
                                        <>
                                            <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/add.png'></img>
                                        </>}
                                    <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 55, left: 30 }} >{props.title}</Col>
                                    <Col>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row gutter={[8, 8]} align={'middle'}>
                                    <Col span={6}>需求修改項目</Col>
                                    <Col span={18}>
                                        <TextArea rows={4} placeholder="請輸入內容" value={props.editcard['item']}
                                            onChange={e => props.setEditCard(prev => {
                                                return (
                                                    {
                                                        ...prev,
                                                        item: e.target.value,
                                                    }
                                                )
                                            })} />
                                    </Col>
                                    <Col span={6}>修改原因</Col>
                                    <Col span={18}>
                                        <TextArea rows={4} placeholder="請輸入內容" value={props.editcard['reason']}
                                            onChange={e => props.setEditCard(prev => {
                                                return (
                                                    {
                                                        ...prev,
                                                        reason: e.target.value,
                                                    }
                                                )
                                            })} />
                                    </Col>
                                    <Col span={6}>驗收測試範例</Col>
                                    <Col span={18}>
                                        <TextArea rows={4} placeholder="請輸入內容" value={props.editcard['accepting_test']}
                                            onChange={e => props.setEditCard(prev => {
                                                return (
                                                    {
                                                        ...prev,
                                                        accepting_test: e.target.value,
                                                    }
                                                )
                                            })} />
                                    </Col>
                                    <Col span={24}>
                                        <Row gutter={[8, 8]} align={'middle'}>
                                            <Col sm={{ span: 24 }} md={{ span: 6 }}>上傳圖片</Col>
                                            <Col sm={{ span: 24 }} md={{ span: 18 }}>
                                                <Upload
                                                    accept="image/png,image/jpeg"
                                                    // customRequest={handleUpload}
                                                    listType="picture-card"
                                                    // fileList={fileList}
                                                    // onPreview={handlePreview}
                                                    // onRemove={e => showConfirmPic(e)}
                                                    // onChange={handleUpload} 
                                                    beforeUpload={false}
                                                    multiple
                                                >
                                                    <div>
                                                        <PlusOutlined />
                                                        <div
                                                            style={{
                                                                marginTop: 8,
                                                            }}
                                                        >
                                                            上傳圖片
                                                        </div>
                                                    </div>
                                                </Upload>
                                            </Col>
                                            {/* <Col span={20}>
                                                    {more_pic == true ? null :
                                                        <Row align={'end'} >
                                                            <Col style={{ cursor: 'pointer', textDecoration: 'underline' }}>更多圖片</Col>
                                                        </Row>}
                                                </Col> */}
                                            <Col span={2}></Col>
                                            <Col span={22}>＊請注意圖片大小，限制在2MB以內</Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row gutter={[10, 10]} justify={"center"}>
                                    <Col>
                                        <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => props.setOpen(false)} block>取消</Button>
                                    </Col>
                                    <Col >
                                        <Button
                                            onClick={e => { props.edit ? props.handleEdit() : props.handleSubmit() }}
                                            size='large' style={{ background: props.edit ? `#${props.color}` : 'rgba(232, 79, 117, 1)', color: '#ffffff' }} block>{props.edit ? '修改' : '送出'}</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div >
                </>}
                centered
            >
            </Modal >}
        </>
    )

}
export default FeedbackModal;